import request from '@/utils/request'

// 统计分析API

// 获取客服统计数据
export function getAgentStatistics(params) {
  return request({
    url: '/api/admin/statistics/agent',
    method: 'get',
    params
  })
}

// 获取租户统计概览
export function getTenantStatistics(params) {
  return request({
    url: '/api/admin/statistics/tenant/overview',
    method: 'get',
    params
  })
}

// 获取客服排名数据
export function getAgentRanking(params) {
  return request({
    url: '/api/admin/statistics/agents/ranking',
    method: 'get',
    params
  })
}

// 获取实时统计数据
export function getRealtimeStatistics(tenantId) {
  return request({
    url: '/api/admin/statistics/realtime',
    method: 'get',
    params: { tenantId }
  })
}

// 获取会话趋势数据
export function getConversationTrend(params) {
  return request({
    url: '/api/admin/statistics/trend',
    method: 'get',
    params
  })
}

// 获取会话统计数据
export function getConversationStatistics(params) {
  return request({
    url: '/api/admin/statistics/conversations',
    method: 'get',
    params
  })
}
